import type { TelStorageConfig } from './tel-storage.js'
import { isClient } from './utils.js'

// these options should be adjusted based on the amount of concurrent users on server and browser memory
const DEFAULT_LOGS_STORAGE_LIMIT = isClient ? 100 : 200
const DEFAULT_SPANS_STORAGE_LIMIT = isClient ? 500 : 1000
const DEFAULT_SPAN_EVENTS_STORAGE_LIMIT = 200 // client only
const DEFAULT_METRICS_STORAGE_LIMIT = 1000
const DEFAULT_EVENTS_BUFFER_LIMIT = isClient ? 20 : 30
const DEFAULT_METRICS_BUFFER_LIMIT = 100

/**
 * A storage config with every default applied. makeTelStorage starts from it and its
 * `_resetConfig` returns to it, so the defaults are declared here and nowhere else.
 */
export function resolveTelStorageConfig(config: TelStorageConfig) {
  const {
    logsStorageLimit = DEFAULT_LOGS_STORAGE_LIMIT,
    spansStorageLimit = DEFAULT_SPANS_STORAGE_LIMIT,
    spanEventsStorageLimit = DEFAULT_SPAN_EVENTS_STORAGE_LIMIT,
    metricsStorageLimit = DEFAULT_METRICS_STORAGE_LIMIT,
    eventsBufferLimit = DEFAULT_EVENTS_BUFFER_LIMIT,
    metricsBufferLimit = DEFAULT_METRICS_BUFFER_LIMIT,
    errorFilterStrings = [],
    errorMapper,
    // The fail-closed default, declared once for the whole package.
    captureSpanOutput = false,
  } = config
  return {
    logsStorageLimit,
    spansStorageLimit,
    spanEventsStorageLimit,
    metricsStorageLimit,
    eventsBufferLimit,
    metricsBufferLimit,
    errorFilterStrings,
    errorMapper,
    captureSpanOutput,
  }
}
